import { get, postJson} from '../axios2'

//会员等级权益管理查询
export const getMemberBenefitInfo = p => postJson(`/memberBenefit/getMemberBenefitInfo`, p);

//添加
export const createMemberBenefitInfo = p => postJson(`/memberBenefit/createMemberBenefitInfo`, p);

//删除
export const deleteMemberBenefitInfo = p => get(`/memberBenefit/deleteMemberBenefitInfo`,p)